import { render, staticRenderFns } from "./ShipmentRecord.vue?vue&type=template&id=0190fa1e&scoped=true&"
import script from "./ShipmentRecord.vue?vue&type=script&lang=js&"
export * from "./ShipmentRecord.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentRecord.vue?vue&type=style&index=0&id=0190fa1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0190fa1e",
  null
  
)

export default component.exports